// Slim top-of-page banner for the $10k hackathon pot.
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

export default function HackathonPotCard() {
  return (
    <Link
      to="/hackathon"
      className="group flex items-center justify-center gap-2 py-1.5 px-4 text-[11px] font-mono uppercase tracking-wider border-b border-border/50 bg-background/80 backdrop-blur hover:bg-primary/5 transition-colors"
    >
      <Trophy className="w-3 h-3 text-primary" />
      <span className="text-primary">$10,000 rolling pot</span>
      <span className="text-muted-foreground">— unlocks at 1,000 members</span>
    </Link>
  );
}
